import {sendAccountKey} from "../messaging";

class Context {
    private _key: undefined | string
    get accountKey(): string | undefined {
        const params = new URLSearchParams(window.location.search)
        return params.get("accountKey") ?? this._key
    }
    set accountKey(key: string | undefined) {
        this._key = key
        if (key !== undefined) {
            sendAccountKey(key)
        }
    }
}

export const context = new Context()